import React, { type FC } from "react";
import { RegisterModalDatameshIds } from "@components/Register/RegistrationBox/config/datameshIds";
import { withPrefix } from "@tracking/tracking";
import { useTrackElement, useTranslation } from "@edreamsodigeo/frontend-core";
import { Body } from "@edreamsodigeo/prisma-design-system";

import type { EmailErrorBody } from "./contract";

export const EmailFormatErrorMessageBody: FC<EmailErrorBody> = ({
  key,
  error,
  trackingPrefix,
  bodyType = "xSmall",
}) => {
  const { t } = useTranslation();

  const trackingRefEmailErrorDisplay = useTrackElement(
    ["display"],
    withPrefix(RegisterModalDatameshIds.onError.emailFormat, trackingPrefix),
  );
  return (
    <Body key={key} type={bodyType} ref={trackingRefEmailErrorDisplay}>
      {t(error)}
    </Body>
  );
};
